import React from 'react';
import { ImageBlock } from 'components/image-block/ImageBlock';
import { TextButton } from 'components/button/TextButton';
import { Divider } from 'components/elements/divider/Divider';

export const Component = () => {
  const image = { url: 'https://picsum.photos/id/942/560/640', width: 560, height: 640 };

  return (
    <>
      <Divider>Image Block</Divider>

      <ImageBlock
        isSlice
        title="Title"
        text={
          <div>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum in nisi et urna
              tempor blandit. Nullam eros felis, tincidunt vitae dui nec, fringilla tempor lorem.
              Vestibulum sit amet lorem placerat, dictum nisi ut, fringilla ipsum. Donec sapien
              enim, accumsan dictum blandit eu, dictum vel felis.
            </p>
          </div>
        }
        image={image}
        link={{ href: 'https://kodo.is' }}
        label="Button label"
        buttonText="Button text"
        buttonCaption="Button caption"
        buttonSubline="Button subline"
        buttonNumber="123"
        caption="Image caption/description"
      >
        <TextButton href="kodo.is">Button one label</TextButton>
        <TextButton href="kodo.is">Button two label</TextButton>
      </ImageBlock>

      <Divider>Image Block with image on left</Divider>

      <ImageBlock
        isSlice
        title="Title"
        direction="Left"
        text={
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum in nisi et urna
            tempor blandit. Nullam eros felis, tincidunt vitae dui nec, fringilla tempor lorem.
            Vestibulum sit amet lorem placerat, dictum nisi ut, fringilla ipsum. Donec sapien enim,
            accumsan dictum blandit eu, dictum vel felis.
          </p>
        }
        image={image}
        link={{ href: 'https://kodo.is' }}
        label="Button label"
        buttonText="Button text"
        buttonCaption="Button caption"
        buttonSubline="Button subline"
        buttonNumber="123"
        caption="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis tincidunt ullamcorper sem, ac facilisis turpis tempor et. Curabitur fermentum cursus scelerisque."
      />

      <Divider>Image Block with video</Divider>

      <ImageBlock
        isSlice
        title="Title"
        direction="Left"
        text={
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum in nisi et urna
            tempor blandit. Nullam eros felis, tincidunt vitae dui nec, fringilla tempor lorem.
            Vestibulum sit amet lorem placerat, dictum nisi ut, fringilla ipsum. Donec sapien enim,
            accumsan dictum blandit eu, dictum vel felis.
          </p>
        }
        image={image}
        video={{ href: '/static/video/black-particle-loop.mp4' }}
        link={{ href: 'https://kodo.is' }}
        label="Button label"
        buttonText="Button text"
        buttonCaption="Button caption"
        buttonSubline="Button subline"
        buttonNumber="123"
      />

      <Divider>Globe variant</Divider>

      <ImageBlock
        isSlice
        title="Title"
        globe={'Show globe'}
        text={
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum in nisi et urna
            tempor blandit. Nullam eros felis, tincidunt vitae dui nec, fringilla tempor lorem.
            Vestibulum sit amet lorem placerat, dictum nisi ut, fringilla ipsum. Donec sapien enim,
            accumsan dictum blandit eu, dictum vel felis.
          </p>
        }
        image={image}
        link={{ href: 'https://kodo.is' }}
      />
    </>
  );
};
